import React, { useEffect, useRef, useState } from "react";
import { MandatoryStar, getSnackbarSuccess } from "../../../Utils/helper";
import { useDispatch } from "react-redux";
import {
  GetQCApprovalDetailsNetworkAction,
  PayoutEditByFinance,
} from "../../../redux/actions/PayoutAction";

export const FinanceAppointmentDetails = ({
  setIsEdit,
  isEdit,
  searchFilter,
  setPayabelData,
}) => {
  const ref = useRef();
  const [data, setData] = useState(null);
  const dispatch = useDispatch();
  const handleChange = (name, value) => {
    console.log("name11", name);
    console.log("value11", value);
    console.log("data?.netAmount", data?.netAmount);
    if (name === "discountType") {
      if (value === "") {
        // Reset everything when "Select Type" is chosen
        setData({
          ...data,
          discountType: "",
          discountAmount: "",
          discountedAmount: "",
        });
      } else if (value === "Percentage" || value === "Amount") {
        // Reset discountAmount & discountedAmount only if Percentage is selected
        setData({
          ...data,
          discountType: value,
          discountAmount: "",
          discountedAmount: "",
        });
      } else {
        // If Amount is selected, keep existing values
        setData({
          ...data,
          discountType: value,
        });
      }
    } else {
      setData({ ...data, [name]: value });
    }
  };
  useEffect(() => {
    setData({
      businessType: isEdit?.data?.buType,
      caseNo: isEdit?.data?.caseNo,
      providerAmount: isEdit?.data?.providerAmount,
      requestID: isEdit?.data?.requestID,
      providerId: isEdit?.data?.providerId,
      homeVisitAmount: isEdit?.data?.homeVisitAmount ?? "",
      remarks: isEdit?.data?.remarks,
      discountAmount: isEdit?.data?.discountAmount ?? "",
      discountedAmount: isEdit?.data?.discountedAmount ?? "",
      discountType: isEdit?.data?.discountType ?? "",
      netAmount: isEdit?.data?.netAmount,
      splitIndividualTestAmount: isEdit?.data?.splitIndividualTestAmount ?? "",
    });
  }, [isEdit]);

  const handleSubmit = (event) => {

   

    event?.preventDefault();
    console.log("data12340999mnnn", data);

    if (!data?.providerAmount) {
      alert("Please fill provider amount.");
      return;
    }
    if (!data?.remarks) {
      alert("Please fill remarks.");
      return;
    }
    if (
      data?.discountType !== "" &&
      (data?.discountAmount === null || data?.discountAmount === "")
    ) {
      alert("Please fill discount amount/percentage.");
      return;
    }

    console.log("Updated Data Before Submission:", data);

    const res = dispatch(PayoutEditByFinance(data));
    if (res) {
      getSnackbarSuccess("success", res?.data?.message, dispatch);
      setTimeout(() => {
        dispatch(GetQCApprovalDetailsNetworkAction(searchFilter));
      }, 2000); // 2-second delay
      setPayabelData([]);
      handleClose();
    }
  };

  const handleClose = () => {
    setIsEdit({ data: null, open: false });
    setPayabelData([]);
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black ">Update Payable</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose()}
        ></button>
      </div>
      <div className="modal-body addusermodalbox">
        <div className="row">
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">Request ID</label>
            <input
              name="requestID"
              type="text"
              disabled={true}
              value={data?.requestID}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
              // onChange={(e) => handleChange("requestID", e.target.value)}
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">Provider Name</label>
            <input
              name="providerName"
              type="text"
              disabled={true}
              value={isEdit?.data?.providerName}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
              // onChange={(e) => handleChange("providerName", e.target.value)}
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">Case Number</label>
            <input
              name="caseNo"
              type="text"
              disabled={true}
              value={data?.caseNo}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
              // onChange={(e) => handleChange("caseNo", e.target.value)}
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              Provider Amount
              <MandatoryStar />
            </label>
            <input
              name="providerAmount"
              type="text"
              placeholder="Enter Here..."
              value={data?.providerAmount}
              onKeyPress={(e) => {
                const value = e.target.value;
                const allowedChars = /^[0-9\b.]+$/;
                if (!allowedChars.test(e.key)) {
                  e.preventDefault();
                }

                // Check if the input already contains a decimal point
                if (e.key === "." && value.includes(".")) {
                  e.preventDefault();
                }

                // Check if the input is going to exceed two decimal places
                if (
                  value.includes(".") &&
                  value.split(".")[1].length >= 2 &&
                  e.key !== "Backspace"
                ) {
                  e.preventDefault();
                }
              }}
              min={1}
              className="form-control form-select-admin inputbgavanish"
              required
              disabled
              onChange={(e) =>
                // data.tds = (
                //   (Number(e.target.value) + data?.homeVisitAmount) /
                //   10
                // ).toString();

                // data.netAmount = (
                //   Number(e.target.value) +
                //   data?.homeVisitAmount -
                //   data?.tds
                // ).toString();

                handleChange("providerAmount", e.target.value)
              }
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              HV Amount
              <MandatoryStar />
            </label>
            <input
              name="homeVisitAmount"
              type="number"
              min={0}
              onKeyPress={(e) => {
                const value = e.target.value;
                const allowedChars = /^[0-9\b.]+$/;
                if (!allowedChars.test(e.key)) {
                  e.preventDefault();
                }

                // Check if the input already contains a decimal point
                if (e.key === "." && value.includes(".")) {
                  e.preventDefault();
                }

                // Check if the input is going to exceed two decimal places
                if (
                  value.includes(".") &&
                  value.split(".")[1].length >= 2 &&
                  e.key !== "Backspace"
                ) {
                  e.preventDefault();
                }
              }}
              value={data?.homeVisitAmount}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
              disabled
              onChange={
                (e) => handleChange("homeVisitAmount", e.target.value)
                // data.tds = (
                //   (Number(data?.providerAmount) + Number(e.target.value)) /
                //   10
                // ).toString();

                // handleChange("netAmount", "");

                // data.netAmount = (
                //   Number(e.target.value) +
                //   Number(data?.providerAmount) -
                //   Number(data?.tds) -
                //   Number(data?.discountedAmount || 0)
                // ).toString();
              }
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              Split Amount
              {/* <MandatoryStar /> */}
            </label>
            <input
              name="splitIndividualTestAmount"
              type="number"
              min={0}
              onKeyPress={(e) => {
                const value = e.target.value;
                const allowedChars = /^[0-9\b.]+$/;
                if (!allowedChars.test(e.key)) {
                  e.preventDefault();
                }

                // Check if the input already contains a decimal point
                if (e.key === "." && value.includes(".")) {
                  e.preventDefault();
                }

                // Check if the input is going to exceed two decimal places
                if (
                  value.includes(".") &&
                  value.split(".")[1].length >= 2 &&
                  e.key !== "Backspace"
                ) {
                  e.preventDefault();
                }
              }}
              value={data?.splitIndividualTestAmount}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              // required
              disabled
              onChange={(e) =>
                handleChange("splitIndividualTestAmount", e.target.value)
              }
            />
          </div>
          {/* <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              TDS
              <MandatoryStar />
            </label>
            <input
              name="tds"
              type="number"
              value={data?.tds}
              min={0}
              disabled
              onKeyPress={(e) => {
                const value = e.target.value;
                const allowedChars = /^[0-9\b.]+$/;
                if (!allowedChars.test(e.key)) {
                  e.preventDefault();
                }

                // Check if the input already contains a decimal point
                if (e.key === "." && value.includes(".")) {
                  e.preventDefault();
                }

                // Check if the input is going to exceed two decimal places
                if (
                  value.includes(".") &&
                  value.split(".")[1].length >= 2 &&
                  e.key !== "Backspace"
                ) {
                  e.preventDefault();
                }
              }}
              placeholder="Enter TDS Amount"
              className="form-control form-select-admin inputbgavanish"
              required
              onChange={(e) => handleChange("tds", e.target.value)}
            />
          </div> */}

          <div className="col-lg- 4 col-md-4">
            <label className="col-form-label">Discount Type</label>
            {/* <MandatoryStar /> */}
            <select
              name="DiscountType"
              className="form-select"
              style={{ height: "40px" }}
              required
              value={data?.discountType}
              onChange={(e) => {
                // data.netAmount = Number(
                //   data?.providerAmount +
                //     data?.homeVisitAmount +
                //     data?.splitIndividualTestAmount
                // ).toString();

                const providerAmount = Number(data?.providerAmount) || 0;
                const homeVisitAmount = Number(data?.homeVisitAmount) || 0;
                const splitIndividualTestAmount =
                  Number(data?.splitIndividualTestAmount) || 0;

                const grossAmount =
                  providerAmount + homeVisitAmount + splitIndividualTestAmount;

                data.netAmount = grossAmount;

                handleChange("discountType", e.target.value);
              }}
            >
              <option value="">Select Type</option>
              <option value="Amount">Amount</option>
              <option value="Percentage">Percentage</option>
            </select>
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              Discount Amount/Percentage
              {/* <MandatoryStar /> */}
            </label>
            <input
              name="discountAmountPercentage"
              type="number"
              min={0}
              onKeyPress={(e) => {
                const value = e.target.value;
                const allowedChars = /^[0-9\b.]+$/;
                if (!allowedChars.test(e.key)) {
                  e.preventDefault();
                }
                // Check if the input already contains a decimal point
                if (e.key === "." && value.includes(".")) {
                  e.preventDefault();
                }
                // Check if the input is going to exceed two decimal places
                if (
                  value.includes(".") &&
                  value.split(".")[1].length >= 2 &&
                  e.key !== "Backspace"
                ) {
                  e.preventDefault();
                }
              }}
              value={data?.discountAmount}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
              disabled={data?.discountType === ""}
              onChange={(e) => {
                if (data?.discountType === "Percentage") {
                  // Calculate percentage-based discount

                  const providerAmount = Number(data?.providerAmount) || 0;
                  const homeVisitAmount = Number(data?.homeVisitAmount) || 0;
                  const splitIndividualTestAmount =
                    Number(data?.splitIndividualTestAmount) || 0;

                  const grossAmount =
                    providerAmount +
                    homeVisitAmount +
                    splitIndividualTestAmount;

                  data.discountedAmount =
                    ((grossAmount * Number(e.target.value.trim())) / 100).toString();

                  data.netAmount = grossAmount - data.discountedAmount;

                } else if (data?.discountType === "Amount") {
                  // Directly assign the amount discount
                  data.discountedAmount = (e.target.value).toString();

                  const providerAmount = Number(data?.providerAmount) || 0;
                  const homeVisitAmount = Number(data?.homeVisitAmount) || 0;
                  const splitIndividualTestAmount =
                    Number(data?.splitIndividualTestAmount) || 0;

                  const grossAmount =
                    providerAmount +
                    homeVisitAmount +
                    splitIndividualTestAmount;

                  data.netAmount = grossAmount - e.target.value;
                }
                handleChange("discountAmount", e.target.value);
              }}
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">
              Discounted Amount
              {/* <MandatoryStar /> */}
            </label>
            <input
              name="discountAmountPercentage"
              type="number"
              value={data?.discountedAmount}
              disabled
              className="form-control form-select-admin inputbgavanish"
              onChange={(e) => {
                handleChange("discountedAmount", e.target.value);
              }}
            />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="col-form-label">Net Amount</label>
            <input
              name="netAmount"
              type="number"
              disabled={true}
              value={data?.netAmount}
              placeholder="Enter Here..."
              className="form-control form-select-admin inputbgavanish"
              required
              onChange={(e) => handleChange("netAmount", e.target.value)}
            />
          </div>
          <div className="col-lg-12 col-md-12 mt-2">
            <label className="col-form-label">
              Remarks
              <MandatoryStar />
            </label>
            <textarea
              required
              className="form-control form-select-admin inputbgavanish"
              rows="5"
              cols="33"
              value={data?.remarks}
              onKeyPress={(e) => {
                const re = /^[a-zA-Z\s]*$/;
                if (e.target.value.trim() === "" && e.key === " ") {
                  e.preventDefault();
                  return;
                }
              }}
              onChange={(e) => handleChange("remarks", e.target.value)}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="modal-footer modal-footer-admin  bottom-0  mt-4">
        <div className="d-flex justify-content-end flex-wrap gap-10">
          <button
            onClick={() => handleClose()}
            type="btn"
            className="savedetails"
          >
            Cancel
          </button>
          <button
            type="btn"
            className="savedetails"
            onClick={() => handleSubmit()}
          >
            Update
            {/* {"Update"} */}
          </button>
        </div>
      </div>
      {/* </form> */}
    </>
  );
};
